export { default } from './Admin.container'



// WEBPACK FOOTER //
// ./src/pages/Admin/index.js